"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const LocationAccessibility = ({ title, body }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [title ? title :
                (0, jsx_runtime_1.jsxs)("h2", Object.assign({ className: "ontario-h3" }, { children: [" ", t("locationAccessibility.title"), " "] })), body] }));
};
exports.default = LocationAccessibility;
